//---------------------
// has duplicate ranks
//---------------------
export default function hasDuplicateRanks(combatants) {
  // console.log("---------------------");
  // console.log("IN getDuplicateRanks len = " + combatants.length);
  let dupes = [];
  //----------------------
  // loop thru combatants
  //----------------------
  for (let i = 0; i < combatants.length; i++) {
    //---------------------------------------------
    // check for potential dupes (same rank + dex)
    //---------------------------------------------
    // cannot just check roll_off == 0 as dupe may
    // be with already rolled combatants and newly
    // added ones
    //---------------------------------------------
    dupes = combatants.filter(
      (c) => c.rank == combatants[i].rank && c.dex == combatants[i].dex
    );
    //-----------------------------
    // where potential dupes exist
    //-----------------------------
    if (dupes.length > 1) {
      //-----------------------------------------------------------------
      // check for non-zero roll-offs in pot dupes i.e. already resolved
      //-----------------------------------------------------------------
      let some_already_resolved = dupes.some((a) => a.roll_off > 0);
      //----------------------------------------------
      // SCENARIO A. all zero roll-offs - return true
      //----------------------------------------------
      if (!some_already_resolved) {
        return true;
        //----------------------------------
        // SCENARIO B. all already resolved
        //----------------------------------
      } else {
        //------------------------
        // count already resolved
        //------------------------
        let already_resolved_count = dupes.filter((a) => a.roll_off > 0).length;
        //----------------------------------------------
        // if all dupes already resolved - return false
        //----------------------------------------------
        if (already_resolved_count == dupes.length) {
          return false;
          //------------------------------------------
          // SCENARIO C. mix of un/resolved roll-offs
          //------------------------------------------
        } else {
          return true;
        }
      }
    }
  }
  return false;
}
